import React from 'react';

import { Layout } from '@components/admin/Layout';
import { BookingCreateFormComplete } from '@components/utilities/BookingInquiry/BookingCreateFormComplete';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '予約作成',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumn,
    flex: 1,
    padding: '1.5rem 2rem',
  },
}));

export const BookingCreateComplete: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title}>
      <div className={classes.container}>
        <BookingCreateFormComplete isDashboard={true} />
      </div>
    </Layout>
  );
};
